var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0005 11.0005H6.83047L9.71047 8.12047C10.1005 7.73047 10.1005 7.10047 9.71047 6.71047C9.32047 6.32047 8.69047 6.32047 8.30047 6.71047L3.71047 11.3005C3.32047 11.6905 3.32047 12.3205 3.71047 12.7105L8.30047 17.3005C8.69047 17.6905 9.32047 17.6905 9.71047 17.3005C10.1005 16.9105 10.1005 16.2805 9.71047 15.8905L6.83047 13.0005H20.0005C20.5505 13.0005 21.0005 12.5505 21.0005 12.0005C21.0005 11.4505 20.5505 11.0005 20.0005 11.0005Z",
    fill: "#052C42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowIcon);
export default __webpack_public_path__ + "static/media/backArrowIcon.b2c617ffeb444b5c2e0bcd9529584510.svg";
export { ForwardRef as ReactComponent };